import { useEffect, useState } from 'react';

import api from './api';


// The server's runtime config never changes while a page is open, so every
// component shares one request for it.
let request = null;

/**
 * The runtime config from /api/config. Null until it resolves, and every flag
 * off if it can't: a page that should be visible staying hidden is a smaller
 * failure than one that shouldn't be visible flashing up.
 */
const useConfig = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let cancelled = false;

    request = request || api.config.getConfig().catch(() => {
      request = null;
      return {};
    });
    request.then((data) => { if (!cancelled) setConfig(data); });

    return () => { cancelled = true; };
  }, []);

  return config;
};

export default useConfig;
